import { render, staticRenderFns } from "./gotop.vue?vue&type=template&id=05b7e785&"
import script from "./gotop.vue?vue&type=script&lang=js&"
export * from "./gotop.vue?vue&type=script&lang=js&"
import style0 from "./gotop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports